import { apiClient } from "./ApiClient";

// ── Account endpoints ────────────────────────────────────────────────────────

/** GET all active accounts, optionally filtered by type ('CUSTOMER' or 'VENDOR') */
export const retrieveAllStakeholderAccountsApi = (type) =>
  apiClient.get(`/stakeholder-accounts`, { params: type ? { type } : {} });

/** GET the account for a specific stakeholder (created lazily if missing) */
export const getOrCreateStakeholderAccountApi = (stakeholderId) =>
  apiClient.get(`/stakeholder-accounts/by-stakeholder/${stakeholderId}`);

/** GET a single account by its own ID */
export const getStakeholderAccountByIdApi = (accountId) =>
  apiClient.get(`/stakeholder-accounts/${accountId}`);

// ── Entry endpoints ──────────────────────────────────────────────────────────

/** GET all ledger entries for an account (chronological) */
export const getAccountEntriesApi = (accountId) =>
  apiClient.get(`/stakeholder-accounts/${accountId}/entries`);

/** GET all entries for a stakeholder */
export const getEntriesByStakeholderApi = (stakeholderId) =>
  apiClient.get(`/stakeholder-accounts/by-stakeholder/${stakeholderId}/entries`);

/**
 * POST filtered entry search within an account.
 * filterDto: { entryType?, status?, entryDateFrom?, entryDateTo? }
 */
export const filterAccountEntriesApi = (accountId, filterDto) =>
  apiClient.post(`/stakeholder-accounts/${accountId}/entries/filter`, filterDto);

/**
 * POST a new ledger entry.
 * entryDto must include either accountId or stakeholderId.
 * Required fields: entryType, entryDate, currency, and at least one of
 *   debitAmount / creditAmount (original) or debitAmountUsd / creditAmountUsd.
 * fxRateToUsd is used to compute USD equivalent when original amounts are supplied.
 */
export const addStakeholderAccountEntryApi = (entryDto) =>
  apiClient.post(`/stakeholder-accounts/entries/add`, entryDto);

/**
 * PUT — reverses a CONFIRMED entry.
 * Creates a mirror entry; both marked REVERSED.
 */
export const reverseStakeholderAccountEntryApi = (entryId) =>
  apiClient.put(`/stakeholder-accounts/entries/${entryId}/reverse`);
